import { getEntitiesByIds } from '@src/utils/cocoa.util'
import { secondsToMinutesRounded } from '@src/utils/date.util'

export const getTrainerText = (item: CocoApi.WorkoutEntity, prefix: string = '') => {
  const { trainers = [] } = item as CocoApi.WorkoutEntity
  const [firstTrainerFromCollection] = trainers || []
  const { firstName, lastName } = firstTrainerFromCollection || {}
  const fullName = `${firstName} ${lastName}`

  if (!lastName && !firstName) return ''

  if (!lastName && firstName) return `${prefix} ${firstName}`

  return `${prefix} ${fullName}`
}

export const getIsPlayButtonVisible = (
  video?: CocoApi.Video,
  isPlaceholder?: boolean,
  isLock?: boolean
) => {
  // never play placeholder or locked videos
  if (isPlaceholder || isLock) return false

  // allow if is a VOD video
  if (video) return true

  return false
}

export const getDescription = (durationInSeconds?: number, trainers?: CocoApi.Trainer[]) => {
  if (!durationInSeconds && !trainers?.length) return

  const classDurationInMinutes = durationInSeconds
    ? `${secondsToMinutesRounded(durationInSeconds)}m`
    : ''

  if (!trainers?.length) return classDurationInMinutes

  const trainerText = getTrainerText({ trainers } as CocoApi.PlayableEntity)

  return `${classDurationInMinutes} • ${trainerText}`
}

export const getFooterTextForLesson = (
  lesson: CocoApi.LessonEntity,
  content?: CocoApi.BODiBlock | CocoApi.Compilation | CocoApi.Program
) => {
  const durationInSeconds = lesson.video?.durationActual ?? lesson.durationEstimate

  const classDurationInMinutes = durationInSeconds
    ? `${secondsToMinutesRounded(durationInSeconds)}m`
    : ''

  if (content) {
    const prefix = classDurationInMinutes ? `${classDurationInMinutes} | ` : ''

    const associatedContent = getEntitiesByIds<CocoApi.ResourceEntity>(
      lesson.associatedContent?.entityIds,
      Object.values(lesson.associatedContent?.entities ?? content.entities ?? {})
    )

    const pdfCount = associatedContent.reduce(
      (count, entity) => (entity.file?.extension === 'pdf' ? count + 1 : count),
      0
    )

    if (pdfCount > 0) return `${prefix}${pdfCount} PDF${pdfCount > 1 ? 's' : ''}`
  }

  return `${classDurationInMinutes}`
}

const MAX_FOOTER_CATEGORIES = 3

export const getFooterText = (
  subcategories?: CocoApi.Category[],
  categories?: CocoApi.Category[],
  durationInSeconds?: number
) => {
  const classDurationInMinutes = durationInSeconds
    ? `${secondsToMinutesRounded(durationInSeconds)}m`
    : ''
  const prefix = classDurationInMinutes ? `${classDurationInMinutes} | ` : ''

  if (subcategories?.length) {
    return `${prefix}${subcategories
      .slice(0, MAX_FOOTER_CATEGORIES)
      .map((item) => item.title)
      .join(', ')}`
  }

  if (categories?.length) {
    return `${prefix}${categories
      .slice(0, MAX_FOOTER_CATEGORIES)
      .map((item) => item.title)
      .join(', ')}`
  }

  return `${classDurationInMinutes}`
}

export const getStatisticsCopy = (statistics?: CocoApi.Statistic[]): string => {
  const formattedStatistics = (statistics ?? []).reduce((acc: any, statistic) => {
    const hasTitle = !!statistic?.title

    if (hasTitle) {
      acc.push({
        label: statistic.title,
        value: statistic.value ?? '',
      })
    }

    return acc
  }, [])

  return formattedStatistics
    .map((statistic: any) => `${statistic.value} ${statistic.label}`.trim())
    .join(' • ')
}
